{
  "hello": "Xin chào",
  "nav": {
    "home": "Trang chủ",
    "convert": "Quy đổi",
    "c2c": "Mua bán token",
    "c2cTab": {
      "buy": "Tôi muốn mua",
      "sell": "Tôi muốn bán"
    },
    "orderList": "Lệnh",
    "orderTab": {
      "buy": "Mua token",
      "sell": "Bán token",
      "fastTrack": "Giao dịch nhanh",
      "open": "Lệnh đang mở",
      "closed": "Lịch sử lệnh"
    },
    "my": "Của tôi"
  },
  "hi": "Xin chào 👋",
  "introCustomerService": "Xin chào! Chào mừng bạn đến với trung tâm hỗ trợ. Đội ngũ của chúng tôi luôn sẵn sàng hỗ trợ bạn. Chúng tôi có thể giúp gì cho bạn?",
  "startConversation": "Bắt đầu cuộc trò chuyện mới",
  "responseTime": "Thời gian phản hồi thông thường",
  "fewMinutes": "Vài phút",
  "sendUsMessage": "Gửi tin nhắn cho chúng tôi",
  "yourConversation": "Cuộc trò chuyện của bạn",
  "cancel": "Hủy"
}
